import React, { Fragment, useEffect, useState, useRef } from "react";
import SaveEditFirst from "../SaveEdit/SaveEditFirst";
import TextareaSubmit from "./TextareaSubmit";
import useClickOutside from "../../../hooks/Screen/useClickOutside";
import useKeyboardShortcuts from "../../../hooks/KeysHandle/useKeyboardShortcuts";
import CreatePortalHOC from "./CreatePortalHOC";
import {
  useLazyFetchPersonInTableQuery,
  useUpdateCustomerDelegationMutation,
} from "../../../utils/customer/customerTable";
import useRequireAuth from "../../../utils/useRequireAuth";
import { Alert, Snackbar } from "@mui/material";
import MuiLoader from "../Loader/MuiLoader";
import { useFetchPermissionTableDataQuery } from "../../../utils/company/companypermissions";
import { ReactComponent as DownArrow } from "../../../assets/images/downArrow.svg";
import { ReactComponent as FedCrossIMG } from "../../../assets/images/fedCrossIMG.svg";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../UniversalComponents/Loader";
import { pushAlert } from "../../../utils/alertSlice";
import { checkAccessPermission } from "../../../utils/utilityFunctions/localServices";

const MultiPerson = ({
  tableidclass,
  FieldType,
  FieldValue,
  FieldChange,
  setDataInputRow,
  UpdateTableField,
  Item,
  Header,
  clientCoord,
  DataRow,
  commonData,
  ItemComplete,
  refetchCustomerData,
  multiData,
}) => {
  const [inputvalue, setInputValue] = useState([]);
  const inputRef = useRef(null);
  const [overlayStyle, setOverlayStyle] = useState({});
  const [samplestate, setsamplestate] = useState(false);
  const [alert, setAlert] = useState({});
  const inputcloseoutside = useClickOutside(() => {
    setDataInputRow(null);
  });
  const token = useRequireAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const { data: permissionsData } = useFetchPermissionTableDataQuery({ token: token?.token });
  // const [selectedRole, setSelectedRole] = useState(null);
  // const [errorMessage, setErrorMessage] = useState("");
  // const [roleError, setRoleError] = useState(false);
  const companyId = JSON.parse(localStorage.getItem("company_data")).company_id;

  const dispatch = useDispatch();

  useEffect(() => {
    if (FieldType === "date" && FieldValue) {
      setInputValue(formatDateForDisplay(FieldValue));
    } else {
      setInputValue(FieldValue);
    }
  }, [FieldValue, FieldType]);

  const formatDateForDisplay = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const formatDateForInput = (date) => {
    if (!date) return "";
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  const handleChange = (e) => {
    let newValue = e.target.value;
    if (FieldType === "date") {
      newValue = formatDateForInput(newValue);
      setInputValue(formatDateForDisplay(newValue)); // Display format
    } else {
      setInputValue(newValue.slice(0, 200));
    }
    FieldChange({ target: { value: newValue } });
  };

  const [fetchPersonInTable, { data: personTableData, isFetching }] = useLazyFetchPersonInTableQuery();
  const [updateCustomerDelegation, { isLoading: delegationLoading }] = useUpdateCustomerDelegationMutation();
  const [searchTerm, setSearchTerm] = useState("");

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: companyId });
  };
  useEffect(() => {
    fetchPersonData("");
  }, []);
  const handleCheck = (e) => {
    setSearchTerm(e.target.value);
  };

  const customerId = ItemComplete?.customer_id?.id;
  const handleSelectPerson = async (event, value, deleteBool) => {
    event.stopPropagation();

    // if (!selectedOption && !deleteBool) {
    //   setRoleError(true);
    //   return;
    // } else {
    //   setRoleError(false);
    // }

    const org_id = JSON.parse(localStorage.getItem("myUserData"))?.org_id;

    const multiDataCheck = Object.keys(multiData).length === 0 ? [String(customerId)] : Object.keys(multiData);
    console.log(multiData, "multiDataCheck864");

    const payload = {
      customer_id: ItemComplete?.customer_id?.id,
      company_id: ItemComplete?.company_id?.value,
      user_id: value?.id,
      email: value?.email,
      org_id: org_id,
      multiData: multiDataCheck,
      owner: 0,
      // company_Id : companyId
      // group_id: selectedOption?.group_name?.id,
    };

    {
      /* {console.log(selectedOption.customer_id, "selectedOption")} 
  
  to send in payload 
  */
    }

    try {
      const updateDelegationResponse = await updateCustomerDelegation({
        token: token?.token,
        data: payload,
        isDelete: deleteBool,
      });
      if (updateDelegationResponse?.data?.success == true) {
        dispatch(pushAlert({ message: "Data updated successfully", type: "success", visible: true }));
        refetchCustomerData();
      } else {
        dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
        refetchCustomerData();
      }
    } catch (error) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
      console.error("Error updating data:", error);
      // setAlert({
      //   open: true,
      //   message: "Error updating data!",
      //   type: "danger",
      // });

      // setLoading(false);
    } finally {
      // setLoading(false);
    }
  };

  const handleCloseAlert = () => {
    setAlert((prevState) => ({ ...prevState, open: false }));
  };

  const options = permissionsData?.data?.data;

  console.log(options, "options");

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const centeredLoader = () => (
    <div className="bg-container-spinner h-full">
      <div className="spinner">Loading...</div>
    </div>
  );

  const userData = useSelector((store) => store?.user);

  const getMultiPersonSelection = (open, personList, clientCoord) => {
    return (
      <>
        <div className="flex items-end">
          <CreatePortalHOC
            isOpen={true}
            // onClose={() => {}}
            position={clientCoord}
            noBackground
            noBoxShadow
            verticalDist={0}
          >
            {/* <div className="table-overlay inset-0 flex items-center justify-end"> */}
            <div
              className={` !p-0 `}
              style={{ width: clientCoord?.element?.width ? `${clientCoord.element.width - 20}px` : "auto" }}
              ref={inputcloseoutside}
            >
              <div className="w-[294px] bg-white rounded-md border shadow-3 pt-3 mb-6 absolute z-[1] ">
                {/* <h5 className="ml-2 text-434852 text-14 font-500">
                  Assigned Role <span className="text-[#F00]">*</span>
                </h5> */}
                {/* {roleError && <div className="text-red-500 ml-2 text-12 mt-1">Please select a role.</div>} */}

                {false && (
                  <div className="relative ml-2 my-2">
                    <div
                      className="flex justify-between items-center w-[270px] h-[35px] p-1 border border-DFE2E5 bg-white cursor-pointer rounded-[5px] px-2 text-383838 text-12 font-400"
                      onClick={toggleDropdown}
                    >
                      {selectedOption ? (
                        selectedOption.group_name.value
                      ) : (
                        <span className="text-gray-300 font-500">Select Role</span>
                      )}
                      <span className={`transition-transform ${isOpen ? "rotate-180" : ""}`}>
                        <DownArrow fill="#535252" />
                      </span>
                    </div>
                    {isOpen && (
                      <div className="absolute z-10 w-[270px] border border-gray-300 bg-white shadow-lg rounded-[5px]  text-383838 text-12 font-400">
                        {options?.map((option, index) => (
                          <div
                            key={index}
                            className="cursor-pointer hover:bg-gray-300 p-1 px-2"
                            onClick={() => handleOptionSelect(option)}
                          >
                            {option.group_name.value}
                          </div>
                        ))}
                      </div>
                    )}
                    {selectedOption && <p className="mt-2 font-bold">{selectedOption.value}</p>}
                  </div>
                )}

                <div
                // onMouseEnter={handleMouseEnter}
                // onMouseLeave={() => {
                //   handleMouseLeave("D0");
                // }}
                >
                  {checkAccessPermission("Delegation") && (
                    <input
                      type="text"
                      placeholder="Type a name or email address"
                      className="ml-2 w-[270px] h-[38px] border-[#B6BBBF] bg-[#F8F8F8] rounded-md text-[12px] font-[400] text-[#848687] mb-2"
                      value={searchTerm}
                      onChange={handleCheck}
                    />
                  )}

                  <div className="pb-3 align-center ">
                    <h3 className="text-14 font-500 ml-4 mb-2 ">Assigned</h3>
                    <ul
                      className="list-none  overflow-y-auto"
                      style={{ maxHeight: checkAccessPermission("Delegation") ? "70px" : "150px" }}
                    >
                      {delegationLoading && <MuiLoader isOpen={delegationLoading} />}
                      {Array.isArray(personList) &&
                        personList?.map((eachInput, index) => {
                          const initials = eachInput.name
                            .split(" ")
                            .filter((word) => word.length > 0)
                            .map((word) => word.charAt(0).toUpperCase())
                            .slice(0, 2)
                            .join("");
                          return (
                            <li
                              key={index}
                              className="list-none cursor-pointer py-1"
                              onClick={(e) =>
                                Boolean(checkAccessPermission("Delegation")) && handleSelectPerson(e, eachInput, true)
                              }
                            >
                              <div className="flex justify-between items-center">
                                <div className="text-[#2999BC] text-12 font-400 flex pl-4 space-x-2">
                                  <div className="bg-white text-10 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                    {initials}
                                  </div>
                                  <p className="mb-1 ">{eachInput.name}</p>
                                </div>
                                <div className="pr-6 mb-1">
                                  <FedCrossIMG />
                                </div>
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                  {checkAccessPermission("Delegation") && (
                    <div>
                      <div>
                        <h3 className="text-14 font-500 ml-4 pb-3">Suggestions</h3>
                      </div>
                      {/* <ul className="pl-5 text-12 font-400 space-y-3 text-[#2999BC]">
                                              {personTableData.map((eachInput, index) => (
                                                <div className="flex space-x-2 cursor-pointer">
                                                <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px] "> {eachInput.name.charAt(0).toUpperCase()}</div>
                                                      <li
                                                        key={index}
                                                        onClick={() => handleSelectPerson(eachInput)}
                                                      >
                                                        {eachInput.name}
                                                      </li>
                                                </div>
                                              ))}
                                            </ul> */}

                      <ul className="pl-5 text-12 font-400 space-y-3 text-[#2999BC] h-[75px] overflow-y-auto  ">
                        {isFetching && <Loader isOpen={delegationLoading} />}

                        {personTableData &&
                          personTableData
                            ?.filter(
                              (eachInput) =>
                                eachInput.name?.toLowerCase().includes(searchTerm || "") &&
                                !(
                                  Array.isArray(personList) &&
                                  personList?.some((eachValue) =>
                                    eachValue.name?.toLowerCase().includes(eachInput.name?.toLowerCase())
                                  )
                                )
                            )
                            .map((eachInput, index) => {
                              const initials = eachInput.name
                                .split(" ")
                                .filter((word) => word.length > 0)
                                .map((word) => word.charAt(0).toUpperCase())
                                .slice(0, 2)
                                .join("");

                              return (
                                <div className="flex space-x-2 cursor-pointer" key={index}>
                                  <div className="bg-white text-10 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                    {initials}
                                  </div>
                                  <li onClick={(e) => handleSelectPerson(e, eachInput)}>{eachInput.name}</li>
                                </div>
                              );
                            })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </CreatePortalHOC>

          <div className="pt-1 space-x-1 flex items-end">
            {Array.isArray(personList) &&
              personList
                ?.filter((assigned, index) => index < 3)
                .map((eachInput, index) => {
                  const initials = eachInput.name
                    .split(" ")
                    .filter((word) => word.length > 0)
                    .map((word) => word.charAt(0).toUpperCase())
                    .slice(0, 2)
                    .join("");

                  return (
                    <div key={index} className="relative">
                      <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300  p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                        {initials}
                      </div>
                      {/* <button
                      className="absolute top-[-4px] right-[-4px] bg-blue-500 text-white rounded-full w-[10px] h-[10px] flex items-center justify-center text-xs cursor-pointer"
                      onClick={(e) => handleSelectPerson(e, eachInput, true)}
                    >
                      &times;
                    </button> */}
                    </div>
                  );
                })}
            {personList?.length > 3 && (
              <div className="">
                <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300   w-7 h-5 flex items-center justify-center rounded-full border-[1px]">
                  + {personList?.length - 3}
                </div>
              </div>
            )}
          </div>
        </div>
        {alert?.open && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert?.open}
            onClose={handleCloseAlert}
            key={"top" + "right"}
            autoHideDuration={1000}
          >
            <Alert
              onClose={handleCloseAlert}
              severity={alert?.type || "success"} // 'success' for green, 'error' for red
              sx={{
                backgroundColor: alert?.type === "success" ? "green" : "red",
                color: "white",
              }}
            >
              {alert?.message}
            </Alert>
          </Snackbar>
        )}
      </>
    );
  };

  useKeyboardShortcuts({
    Enter: (event) => {
      event.preventDefault();
      UpdateTableField(event, { value: inputvalue }, Item);
    },
    Escape: (event) => {
      event.preventDefault();
      setDataInputRow(null);
    },
  });

  return (
    <Fragment>
      {true ? (
        <Fragment>
          {/* <input
            ref={inputRef}
            className="p-3 w-full h-[33px] bg-white"
            disabled
            readOnly
          /> */}

          {/* <div className="absolute left-1/2 transform -translate-x-1/2 z-10 mt-3 w-[300px]"> */}
          {/* <div className={`w-full absolute top-0 h-full ${HoverActiveClass}`} ref={dropdownRef} onMouseOver={handleOpen} onMouseLeave={handleClose}>
            </div> */}

          {/* <TextareaSubmit
                Value={inputvalue}
                onChange={handleChange}
                handleSaveEvent={(e) =>
                  UpdateTableField(e, { value: inputvalue }, Item)
                }
              /> */}

          {getMultiPersonSelection(true, inputvalue, clientCoord)}
        </Fragment>
      ) : (
        <Fragment>
          <input
            type={FieldType === "number" ? "text" : FieldType}
            value={inputvalue}
            onChange={handleChange}
            className="p-3 w-full h-[33px]"
          />

          <SaveEditFirst
            UpdateTableField={(e) => UpdateTableField(e, { value: inputvalue }, Item)}
            handleCloseClick={(e) => {
              e.stopPropagation();
              setDataInputRow(null);
            }}
          />
        </Fragment>
      )}
    </Fragment>
  );
};
export default MultiPerson;
